import { EventStatus } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/display.ts";

export const EventStatusOptions = convertMapToOpts(EventStatus, ([_, value]) =>
  toTitleCaseString(value)
);
